import * as Yup from "yup";


const schema = Yup.object({
  id: Yup.string(),
  type: Yup.string().required("Type is required"),
});
export default schema;
